import TtamLocation from './location/index.vue';
import TtamLocationTips from './tips/index.vue';
import TtamLocationSelectedBox from './location-selected-box/index.vue';
import TtamLocationBulkUpload from './bulk-upload/index.vue';
import TtamLocationUndoCurrentChanges from './undo-current-changes/index.vue';
import * as hooks from './hooks';
import { generateLocationTargetingAdContext } from './utils';

export default {
  TtamLocation,
  TtamLocationTips,
  TtamLocationSelectedBox,
  TtamLocationBulkUpload,
  TtamLocationUndoCurrentChanges,
  generateLocationTargetingAdContext,
  ...hooks,
};
